import { render } from "./GanttGridGroupBar.vue?vue&type=template&id=bb4657a2"
import script from "./GanttGridGroupBar.vue?vue&type=script&lang=ts"
export * from "./GanttGridGroupBar.vue?vue&type=script&lang=ts"
script.render = render

export default script